import styled from 'styled-components';
import { InvalidConfigurationModalContentStyled } from '../InvalidConfigurationModalContentStyled';

export const InvalidConfigurationModalContentStyledAC = styled(InvalidConfigurationModalContentStyled)``;
